import type { ReactNode } from 'react';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';

/** Renders its children only when the connected wallet owns the viewed portfolio. */
export function OwnPortfolioOnly(t0) {
  const {
    children
  } = t0;
  const {
    isSelf
  } = useViewedAccountAddress();
  return isSelf ? children : null;
}